type AnyClass = { new (...args: any[]): any };
type Global = typeof globalThis;
type GlobalClasses = {
    [Name in keyof Global as Global[Name] extends AnyClass
        ? Name
        : never]: Global[Name];
};

// フロントのwindow下とworker下でアクセス可能性が異なるクラスについて一元的に操作するためのクラス
export function instanceOf<Name extends keyof GlobalClasses>(
    instance: any,
    className: Name
): instance is InstanceType<GlobalClasses[Name]> {
    return (
        globalThis[className] &&
        instance instanceof (globalThis[className] as AnyClass)
    );
}
